// src/store/drawingDownload.js
const state = {
    visible: false,
    materials: [],
    scope: 2,       // 2 = LATEST_SPEC, 1 = PDS_NEW_OLD
    module: '',
};

const mutations = {
    setVisible(state, v) { state.visible = v; },
    setPayload(state, {materials, scope, module}) {
        state.materials = materials || [];
        state.scope = scope || 2;
        state.module = module || '';
    },
};

const actions = {
    open(context, payload) {
        context.commit('setPayload', payload);
        context.commit('setVisible', true);
    },
    close(context) { context.commit('setVisible', false); },
};

export default { namespaced: true, state, mutations, actions };
